import React, { useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { observer } from 'mobx-react';

import ModalService from 'services/ModalService';
import { useStores } from 'stores/StoreContextProvider';
import SFWOverlay from 'components/SFWOverlay/SFWOverlay';
import ACCESS_LEVEL_NUM from 'enum/accessLevelsNum';

import MyShopThumbnail from './MyShopThumbnail';
import styles from './index.css';


const MyShopItem = (props) => {
  const {
    desktop,
    handleLike,
    hasAccess,
    item,
    myShopHandleBack,
    setShowRegistrationModal,
    user,
  } = props;

  const { PaymentStore } = useStores();
  const { balance } = PaymentStore;

  const isAdmin = user.accessLevel >= ACCESS_LEVEL_NUM.ADMIN;
  const access = hasAccess || item.purchaseSuccess || isAdmin;
  const isSfw = user.user.getIn(['user', 'sfw']);

  const onOpenVideoModal = useCallback(() => {
    if (isSfw) {
      return;
    }

    ModalService.showModal(
      ModalService.MODAL_KEYS.MY_SHOP_VIDEO_MODAL,
      {
        item,
        handleLike,
        hasAccess,
        user,
        balance,
        setShowRegistrationModal,
        isAdmin,
      }
    );
    myShopHandleBack();
  }, [
    balance,
    handleLike,
    hasAccess,
    isAdmin,
    isSfw,
    item,
    myShopHandleBack,
    setShowRegistrationModal,
    user,
  ]);

  const sfwOverlayElement = useMemo(() => {
    if (!isSfw) {
      return null;
    }

    return (
      <SFWOverlay />
    );
  }, [isSfw]);

  const containerClasses = classNames({
    [styles.desktopWrapper]: desktop,
    [styles.wrapper]: !desktop,
  });

  return (
    <div className={containerClasses}>
      {sfwOverlayElement}
      <MyShopThumbnail
        hasAccess={access}
        item={item}
        user={user}
        onClick={onOpenVideoModal}
      />
      <div className={styles.itemInfo}>
        <p className={styles.itemTitle}>
          {item.title}
        </p>
      </div>
    </div>
  );
};

MyShopItem.propTypes = {
  setShowRegistrationModal: PropTypes.func.isRequired,
  desktop: PropTypes.bool,
  handleLike: PropTypes.func,
  hasAccess: PropTypes.bool,
  item: PropTypes.object,
  myShopHandleBack: PropTypes.func,
  user: PropTypes.object,
};

MyShopItem.defaultProps = {
  desktop: undefined,
  handleLike: undefined,
  hasAccess: undefined,
  item: undefined,
  myShopHandleBack: () => undefined,
  user: undefined,
};

export default observer(MyShopItem);
